export enum SaveCapabilites {
  FinalAndIntermediateVersion = 1,
  FinalVersionOnly = 2,
  NoSaving = 3,
}
